<rx-select
	[id]="'case-type-select'"
	[label]="('OrderSection.CaseType' | translate) + ':'"
	[formControl]="control"
	[options]="options"
	[isRequired]="isRequired"
	[compareWith]="compareOptions"
	[getOptionId]="generateOptionId"
	[getOptionName]="getOptionName"
></rx-select>
